import React from "react";
import { createRoot } from "react-dom/client";
import AccountPreferenceForm from "./Components/AccountPreferenceForm";
import "./styles/messagePreferenceStyles.scss";
var rootElement = document.getElementById("message-preference-form-root");
if (rootElement !== null) {
    createRoot(rootElement).render(React.createElement(React.StrictMode, null,
        React.createElement(AccountPreferenceForm, null)));
}
